// document.addEventListener("DOMContentLoaded", () => {
//   const headerWrapper = document.querySelector(".header-wrapper");
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");

//   if (!headerWrapper) return;

//   headerWrapper.addEventListener("click", () => {
//     headerWrapper.classList.add("menu-active,color-scheme-1");
//   });

//   menuItems.forEach(item => {
//     const megaMenu = item.querySelector(".mega-menu__content");

//     if (!megaMenu) return;

//     // Show on hover
//     item.addEventListener("mouseenter", () => {
//       megaMenu.classList.add("mega-menu--open");
//       headerWrapper.classList.add("menu-active");
//     });

//     // Hide on out
//     item.addEventListener("mouseleave", () => {
//       megaMenu.classList.remove("mega-menu--open");
//       headerWrapper.classList.remove("menu-active");
//     });
//   });
// });
// document.addEventListener("click", function(e){

//   const nextBtn = e.target.closest(".slider-button--next");
//   const prevBtn = e.target.closest(".slider-button--prev");

//   if(!nextBtn && !prevBtn) return;

//   const slider = e.target.closest("media-gallery")?.querySelector(".quickadd-gallery");
//   if(!slider) return;

//   const slideWidth = slider.querySelector(".product__media-item")?.offsetWidth || 300;

//   if(nextBtn){
//     slider.scrollBy({
//       left: slideWidth,
//       behavior: "smooth"
//     });
//   }

//   if(prevBtn){
//     slider.scrollBy({
//       left: -slideWidth,
//       behavior: "smooth"
//     });
//   }

// });
// document.addEventListener('DOMContentLoaded', function () {
//   const smallBtn = document.querySelector('.grid-small');
//   const largeBtn = document.querySelector('.grid-large');

//   function changeGrid(cols, activeBtn) {
//     const productGrid = document.querySelector('#product-grid');

//     if (!productGrid) return;

//     // Remove existing desktop grid classes
//     productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, '');

//     // Add new grid class
//     productGrid.classList.add(`grid--${cols}-col-desktop`);

//     // Active state
//     smallBtn.classList.remove('active');
//     largeBtn.classList.remove('active');
//     activeBtn.classList.add('active');
//   }

//   if (smallBtn) {
//     smallBtn.addEventListener('click', function () {
//       changeGrid(3, this);
//     });
//   }

//   if (largeBtn) {
//     largeBtn.addEventListener('click', function () {
//       changeGrid(5, this);
//     });
//   }

//   // Default active state on page load
//   largeBtn?.classList.add('active');
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const textarea = document.getElementById("ContactForm-body");

//   if (!textarea) return;

//   const autoResize = () => {
//     if (textarea.value.trim() === "") {
//       textarea.style.height = "53px"; // reset when empty
//     } else {
//       textarea.style.height = "auto";
//       textarea.style.height = textarea.scrollHeight + "px";
//     }
//   };

//   // Run on load (important)
//   autoResize();

//   // Run on input
//   textarea.addEventListener("input", autoResize);
// });


// document.addEventListener('DOMContentLoaded', () => {
//   const stickyBar = document.getElementById('sticky-atc-bar');
//   const originalATC = document.querySelector('product-form button[type="submit"]');

//   if (!stickyBar || !originalATC) return;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         stickyBar.classList.remove('active');
//       } else {
//         stickyBar.classList.add('active');
//       }
//     },
//     {
//       threshold: 0.1
//     }
//   );

//   observer.observe(originalATC);
// });
document.addEventListener('DOMContentLoaded', function () {

  const desktopSmall = document.querySelector('.grid-small');
  const desktopLarge = document.querySelector('.grid-large');

  const mobileSmall = document.querySelector('.grid-small-mobile');
  const mobileLarge = document.querySelector('.grid-large-mobile');

  function changeGrid(cols, activeButtons) {
    const productGrid = document.querySelector('#product-grid');

    if (!productGrid) return;

    // Remove existing classes
    productGrid.className = productGrid.className
      .replace(/grid--\d+-col-desktop/g, '')
      .replace(/grid--\d+-col-tablet-down/g, '');

    // Desktop
    if (window.innerWidth > 749) {
      productGrid.classList.add(`grid--${cols}-col-desktop`);
    }
    // Mobile
    else {
      productGrid.classList.add(`grid--${cols}-col-tablet-down`);
    }

    // Remove active class from all buttons
    [
      desktopSmall,
      desktopLarge,
      mobileSmall,
      mobileLarge
    ].forEach(btn => btn?.classList.remove('active'));

    // Add active class
    activeButtons.forEach(btn => btn?.classList.add('active'));
  }

  // Desktop
  desktopSmall?.addEventListener('click', function () {
    changeGrid(3, [desktopSmall]);
  });

  desktopLarge?.addEventListener('click', function () {
    changeGrid(5, [desktopLarge]);
  });

  // Mobile
  mobileSmall?.addEventListener('click', function () {
    changeGrid(1, [mobileSmall]); // 1 column mobile
  });

  mobileLarge?.addEventListener('click', function () {
    changeGrid(2, [mobileLarge]); // 2 columns mobile
  });

  // Default state
  if (window.innerWidth > 749) {
    desktopLarge?.classList.add('active');
  } else {
    mobileLarge?.classList.add('active');
  }

});

//////////// Low Inventory Js ///////////////
(function () {

  function getSingleInventoryData(){
    const produtData = document.querySelector('.produtData');
    
  }

  function getInventoryData(form) {
    const dataElement = form.querySelector('.low-inventory-data');

    if (!dataElement) {
      return null;
    }

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Low inventory JSON error:', error);
      return null;
    }
  }

  function getLowInventoryStatus(form) {
    const config = form.querySelector('.low-inventory-config');
    const variantInput = form.querySelector('.product-variant-id');

    if (!config || !variantInput) {
      return null;
    }

    const enabled = config.dataset.lowInventoryEnabled === 'true';
    const threshold = Number(config.dataset.lowInventoryThreshold || 0);
    const variants = getInventoryData(form);

    if (!variants) {
      return null;
    }

    const variantId = String(variantInput.value);
    const variant = variants[variantId];

    if (!variant) {
      return null;
    }

    const inventory = Number(variant.inventory || 0);

    let canAddToCart;

    if (!variant.inventory_management) {
      canAddToCart = variant.available === true;
      } else if (variant.inventory_policy === 'continue') {
      canAddToCart = variant.available === true;
      } else if (enabled) {
        canAddToCart = inventory > threshold;
      } else {
        canAddToCart = inventory > 0;
      }

    if (!variant.available) {
      canAddToCart = false;
    }else{
      document.querySelector("product-form.product-form")?.classList.remove("sold-out");
    }

    return {
      canAddToCart,
      inventory,
      threshold,
      enabled,
      variantId
    };
  }

function updateButtons(form) {
  const status = getLowInventoryStatus(form);
  const stickybar = document.getElementById("sticky-atc-bar");

  if (!status) {
    return;
  }

  if (!status.canAddToCart) {
    stickybar.style.display = "none";
    stickybar.classList.remove("show");
}

  const config = form.querySelector('.low-inventory-config');
  const quantityAndButton = form.querySelector('.product-form__buttons');
  const messageText = config?.dataset.lowInventoryMessage || '';

  let message = form.querySelector('.low-inventory-message');

  if (!message && quantityAndButton) {
    message = document.createElement('div');
    message.className = 'low-inventory-message';
    message.setAttribute('role', 'status');

    quantityAndButton.insertAdjacentElement('afterend', message);
  }

  if (!status.canAddToCart && status.inventory > 0) {
    if (message) {
      message.textContent = messageText;
      message.style.display = 'block';
    }
  } else {
    if (message) {
      message.style.display = 'none';
    }
  }
  

  const buttons = [];

  form.querySelectorAll('.product-form__submit').forEach(function (button) {
    buttons.push(button);
  });

  if (form.id) {
    document
      .querySelectorAll(
        `button.product-form__submit[form="${CSS.escape(form.id)}"]`
      )
      .forEach(function (button) {
        if (!buttons.includes(button)) {
          buttons.push(button);
        }
      });
  }

  buttons.forEach(function (button) {
    if (status.canAddToCart) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');

      const span = button.querySelector('span');

      if (span) {
        span.textContent =
          window.variantStrings?.addToCart || 'Add to cart';
      }
    } else {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');

      const span = button.querySelector('span');

      if (span) {
        span.textContent =
          window.variantStrings?.soldOut || 'Sold out';
        document.querySelector("product-form.product-form")?.classList.add("sold-out");
      }
    }
  });
}

  function initializeForm(form) {
    if (!form || !form.matches('form[data-type="add-to-cart-form"]')) {
      return;
    }

    if (!form.querySelector('.low-inventory-data')) {
      return;
    }

    if (form.dataset.lowInventoryInitialized === 'true') {
      updateButtons(form);
      return;
    }

    form.dataset.lowInventoryInitialized = 'true';

    updateButtons(form);

    const variantInput = form.querySelector('.product-variant-id');

    if (!variantInput) {
      return;
    }

    let previousVariantId = variantInput.value;

    setInterval(function () {
      if (!document.body.contains(form)) {
        return;
      }

      const currentVariantId = variantInput.value;

      if (currentVariantId !== previousVariantId) {
        previousVariantId = currentVariantId;
        updateButtons(form);
      }
    }, 100);
  }

  window.initializeLowInventoryForms = function (container) {
    container = container || document;

    container
      .querySelectorAll('form[data-type="add-to-cart-form"]')
      .forEach(function (form) {
        initializeForm(form);
      });
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.initializeLowInventoryForms(document);
  });

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('button.product-form__submit');

      if (!button) {
        return;
      }

      let form = null;

      const formId = button.getAttribute('form');

      if (formId) {
        form = document.getElementById(formId);
      }

      if (!form) {
        form = button.closest('form[data-type="add-to-cart-form"]');
      }

      if (!form) {
        return;
      }

      const status = getLowInventoryStatus(form);

      if (!status) {
        return;
      }

      if (!status.canAddToCart) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');

        const message = form.querySelector('.low-inventory-message');

        if (message) {
          message.textContent =
            message.dataset.lowInventoryMessage ||
            message.textContent.trim();
          message.style.display = 'block';
        }

        return false;
      }
    },
    true
  );

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.matches?.('form[data-type="add-to-cart-form"]')) {
          initializeForm(node);
        }

        node
          .querySelectorAll?.('form[data-type="add-to-cart-form"]')
          .forEach(function (form) {
            initializeForm(form);
          });
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
